var map = {
	"./en.json": [
		1075,
		98
	],
	"./ro.json": [
		1076,
		99
	],
	"./ru.json": [
		1077,
		100
	],
	"./tr.json": [
		1078,
		101
	],
	"./widgets/en.json": [
		764,
		9
	],
	"./widgets/ro.json": [
		765,
		10
	],
	"./widgets/ru.json": [
		766,
		11
	],
	"./widgets/tr.json": [
		767,
		12
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 663;
module.exports = webpackAsyncContext;